"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4329],{

/***/ 16179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nI": function() { return /* binding */ subscriptionPlansConfig; }
/* harmony export */ });
/* unused harmony exports validSubscriptionFilter, orgWithSubscriptionFilter, limitNamesMapper, limitNames, betterLimitName, FREE_TRIAL_DAYS, internalEmailPriceId, FREE_TRIAL_PLAN_ID, subscriptionSorter, getUsageWindowStartDate, getPlanConfig, mergePlanLimits, salespackEmailsDomain */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61079);
/* provided dependency */ var process = __webpack_require__(44675);


var validSubscriptionFilter = {
    status: {
        in: [
            "active",
            "trialing",
            "past_due"
        ]
    }
};
var orgWithSubscriptionFilter = {
    OR: [
        {
            subscriptions: {
                some: {
                    status: {
                        in: [
                            "active",
                            "trialing",
                            "past_due"
                        ]
                    }
                }
            }
        },
        {
            createdAt: {
                gte: nDaysAgo(7)
            }
        }, 
    ]
};
function nDaysAgo(n) {
    var d = new Date();
    d.setDate(d.getDate() - n);
    return d;
}
var limitNamesMapper = {
    maxEmails: "Emails per month",
    maxUsersNumber: "Max members"
};
var limitNames = Object.keys(limitNamesMapper);
function betterLimitName(name) {
    return limitNamesMapper[name];
}
if (false) {}
var isProd = "production" === "production";
var isSeeding = !!process.env.SEEDING;
var FREE_TRIAL_DAYS = 7;
// generated from seed-stripe.ts
var prodProductIds = {
    "500": "prod_MdZXQm0tcdKSwA",
    "5k": "prod_MdZXt0vTwGS6Kc",
    "10k": "prod_MdZXvtvyLIDurS",
    "50k": "prod_MdZX5KqgEwn7wo",
    "100k": "prod_MdZXOoxlBfQcR9",
    "300k": "prod_MdZXfdM63qCkue",
    "600k": "prod_MdZXiaucou4ERn",
    "1M": "prod_MdZXGxk2ewQyP5"
};
var devProductIds = {
    "500": "prod_Ma83sV8tBzqSF8",
    "5k": "prod_Ma83k6O237WBf5",
    "10k": "prod_Ma83xxa2P2zqlP",
    "50k": "prod_Ma84wqAx42i9Y7",
    "100k": "prod_Ma84Be0vpG0aMz",
    "300k": "prod_Ma84mMZbRqKNM9",
    "600k": "prod_Ma845fGSbJYxNl",
    "1M": "prod_Ma84fp1gdDbSb1"
};
// TODO put the prod emails price id in data file
var internalEmailPriceId = (/* unused pure expression or super */ null && (isProd ? "price_1M4Qz3DRDqyAciXXAj14IflA" : "price_1M46oGDRDqyAciXXXWOZolY9"));
var subscriptionPlansConfig = [
    {
        limits: {
            maxEmails: 500,
            maxUsersNumber: 1
        },
        name: "500",
        description: "500 emails"
    },
    {
        limits: {
            maxEmails: 5000,
            //
            maxUsersNumber: 3
        },
        name: "5k",
        description: "5k emails"
    },
    {
        limits: {
            maxEmails: 10000,
            //
            maxUsersNumber: 5
        },
        name: "10k",
        description: "10k emails"
    },
    {
        limits: {
            maxEmails: 50000,
            //
            maxUsersNumber: 10
        },
        name: "50k",
        description: "50k emails"
    },
    {
        limits: {
            maxEmails: 100000,
            //
            maxUsersNumber: 10
        },
        name: "100k",
        description: "100k emails"
    },
    {
        limits: {
            maxEmails: 300000,
            //
            maxUsersNumber: 10
        },
        name: "300k",
        description: "300k emails"
    },
    {
        limits: {
            maxEmails: 600000,
            //
            maxUsersNumber: 10
        },
        name: "600k",
        description: "600k emails"
    },
    {
        limits: {
            maxEmails: 1000000,
            //
            maxUsersNumber: 10
        },
        name: "1M",
        description: "1M emails"
    }, 
].map(function(x) {
    var productId = isProd ? prodProductIds[x.name] : devProductIds[x.name];
    if (!isSeeding && !productId) {
        throw new Error("Product id for ".concat(x.name, " is not present"));
    }
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, x), {
        productId: productId
    });
});
var FREE_TRIAL_PLAN_ID = subscriptionPlansConfig.find(function(x) {
    return x.name === "500";
}).productId;
if (!isSeeding && !FREE_TRIAL_PLAN_ID) {
    throw new Error("FREE_TRIAL_PLAN_ID is not set");
}
function subscriptionSorter(a, b) {
    var prodA = getPlanConfig({
        productId: a.productId
    });
    var prodB = getPlanConfig({
        productId: b.productId
    });
    if (prodA && prodB) {
        var ref, ref1;
        return (prodB === null || prodB === void 0 ? void 0 : (ref = prodB.limits) === null || ref === void 0 ? void 0 : ref.maxEmails) - (prodA === null || prodA === void 0 ? void 0 : (ref1 = prodA.limits) === null || ref1 === void 0 ? void 0 : ref1.maxEmails);
    }
    return 0;
}
function getUsageWindowStartDate() {
    var now = new Date();
    var firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    return firstDay;
}
function getPlanConfig(p) {
    var productId = p === null || p === void 0 ? void 0 : p.productId;
    var plan = subscriptionPlansConfig.find(function(p) {
        return p.productId === productId;
    });
    // if (productId && !plan && !p.isSandbox) {
    //     throw new Error(`No max emails found for plan ${productId}`)
    // }
    if (!plan) {
        return null;
    }
    return plan;
}
// problem: if i create upsells for stuff like 1 more domain, i need to compute the sum of the numbers instead of taking the bigger one
// what if i always make the sum if one limit is a number?
// problem: if limits are connected to subscription every time i want to make users upsell i need to create new plans
// this makes sense if i want to increase prices
// this makes sense for lifetime deals after camp end
function mergePlanLimits(productIds) {
    if (!productIds) {
        productIds = [];
    }
    var limitsArr = productIds.map(function(x) {
        var ref;
        return (ref = getPlanConfig({
            productId: x
        })) === null || ref === void 0 ? void 0 : ref.limits;
    });
    // add free plan if no subscription
    // limitsArr.push(getPlanConfig({ productId: isProd ? '' : ''
    var mergedLimits = Object.fromEntries(limitNames.map(function(k) {
        return [
            k,
            limitsArr.filter(Boolean).map(function(x) {
                return x[k];
            }).reduce(function(a, b) {
                if (typeof a === "number" && typeof b === "number") {
                    return (a || 0) + (b || 0);
                }
                if (typeof a === "boolean" || typeof b === "boolean") {
                    return a || b;
                }
                return a;
            }, {}), 
        ];
    }));
    return mergedLimits;
}
var salespackEmailsDomain = "spackemail.com";


/***/ }),

/***/ 70853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ createStripeCheckoutSession; },
/* harmony export */   "p": function() { return /* binding */ createStripePortal; }
/* harmony export */ });
/* harmony import */ var next_rpc_dist_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93499);

var createStripeCheckoutSession = /*#__PURE__*/ (0,next_rpc_dist_browser__WEBPACK_IMPORTED_MODULE_0__/* .createRpcFetcher */ .m)("/api/stripe", "createStripeCheckoutSession");
var createStripePortal = /*#__PURE__*/ (0,next_rpc_dist_browser__WEBPACK_IMPORTED_MODULE_0__/* .createRpcFetcher */ .m)("/api/stripe", "createStripePortal");


/***/ }),

/***/ 18717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ SelectOrg; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(61706);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(96424);
// EXTERNAL MODULE: ../node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(98725);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
// EXTERNAL MODULE: ../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(65443);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/.pnpm/swr@1.3.0_react@18.2.0/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(12976);
// EXTERNAL MODULE: ../beskar/src/utils.ts
var utils = __webpack_require__(2177);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.2_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(77577);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(89874);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(42928);
// EXTERNAL MODULE: ../node_modules/.pnpm/styled-jsx@5.0.7_react@18.2.0/node_modules/styled-jsx/style.js
var style = __webpack_require__(65184);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/listbox/listbox.js + 4 modules
var listbox = __webpack_require__(63483);
// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/solid/esm/SelectorIcon.js
var SelectorIcon = __webpack_require__(83170);
// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/solid/esm/CheckIcon.js
var CheckIcon = __webpack_require__(89361);
// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/outline/esm/PlusIcon.js
var PlusIcon = __webpack_require__(389);
// EXTERNAL MODULE: ../node_modules/.pnpm/color-hash@2.0.1/node_modules/color-hash/dist/color-hash.js
var color_hash = __webpack_require__(79758);
var color_hash_default = /*#__PURE__*/__webpack_require__.n(color_hash);
// EXTERNAL MODULE: ../node_modules/.pnpm/colord@2.9.2/node_modules/colord/index.mjs
var colord = __webpack_require__(85799);
// EXTERNAL MODULE: ../node_modules/.pnpm/colord@2.9.2/node_modules/colord/plugins/mix.mjs
var mix = __webpack_require__(96562);
// EXTERNAL MODULE: ../node_modules/.pnpm/colord@2.9.2/node_modules/colord/plugins/harmonies.mjs
var harmonies = __webpack_require__(1323);
// EXTERNAL MODULE: ../node_modules/.pnpm/baby-i-am-faded@4.0.14_react@18.2.0/node_modules/baby-i-am-faded/esm/index.js + 1 modules
var esm = __webpack_require__(37833);
;// CONCATENATED MODULE: ../beskar/src/Select.tsx












/**
 * Needs to have orgId param in query
 */ var Select = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var onChange = param.onChange, value = param.value, _endButton = param.endButton, endButton = _endButton === void 0 ? null : _endButton, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Loading" : _placeholder, options = param.options, _className = param.className, className = _className === void 0 ? "" : _className, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _useAutoGradientIcons = param.useAutoGradientIcons, useAutoGradientIcons = _useAutoGradientIcons === void 0 ? false : _useAutoGradientIcons;
    var router = (0,next_router.useRouter)();
    var orgId = router.query.orgId || "";
    var hoverClasses = "hover:bg-gray-100 hover:dark:bg-gray-600 rounded mx-2";
    var current = options.find(function(x) {
        return x.value === value;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
            value: orgId,
            onChange: onChange,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-cf56417ef7cbaa5a" + " " + (classnames_default()("relative") || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                        ref: ref,
                        as: "button",
                        className: classnames_default()("relative w-full py-[8px] pl-3 pr-10 text-left bg-white rounded-lg shadow-sm shadow border dark:bg-gray-700 focus:outline-none focus-visible:ring-1 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-gray-300 focus-visible:ring-offset-1 sm:text-sm", className),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                "aria-label": "current org",
                                className: "jsx-cf56417ef7cbaa5a" + " " + "flex items-center space-x-2 truncate font-medium",
                                children: [
                                    useAutoGradientIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientIcon, {
                                        name: isLoading ? "" : (current === null || current === void 0 ? void 0 : current.name) || (current === null || current === void 0 ? void 0 : current.value)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-cf56417ef7cbaa5a" + " " + "",
                                        children: isLoading ? "Loading" : (current === null || current === void 0 ? void 0 : current.name) || placeholder
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "jsx-cf56417ef7cbaa5a" + " " + "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorIcon/* default */.Z, {
                                    className: "w-5 h-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    (0,jsx_runtime.jsx)((style_default()), {
                        id: "cf56417ef7cbaa5a",
                        children: "@-webkit-keyframes menuAppear{from{opacity:0;-webkit-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@-moz-keyframes menuAppear{from{opacity:0;-moz-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@-o-keyframes menuAppear{from{opacity:0;transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@keyframes menuAppear{from{opacity:0;-webkit-transform:translate3d(0px,-2em,0px)scale(0);-moz-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Faded */.A, {
                        animationName: "menuAppear",
                        duration: 120,
                        cascade: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Options */.R.Options, {
                            className: classnames_default()("absolute z-50 gap-2 flex flex-col w-full py-2 mt-1 overflow-auto text-base bg-white rounded-md shadow-xl dark:bg-gray-700 max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"),
                            children: [
                                options === null || options === void 0 ? void 0 : options.map(function(opt, idx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                                        className: function className(param) {
                                            var active = param.active;
                                            return classnames_default()("cursor-pointer select-none relative py-[6px] pr-10 ", opt.value === value && "bg-gray-100 dark:bg-gray-600", hoverClasses);
                                        },
                                        value: opt.value,
                                        children: function children(param) {
                                            var selected = param.selected, active = param.active;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-cf56417ef7cbaa5a" + " " + (classnames_default()("flex items-center space-x-2 pl-2 truncate font-medium") || ""),
                                                        children: [
                                                            useAutoGradientIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientIcon, {
                                                                name: (opt === null || opt === void 0 ? void 0 : opt.name) || (opt === null || opt === void 0 ? void 0 : opt.value)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "jsx-cf56417ef7cbaa5a" + " " + "text-sm",
                                                                children: opt.name || opt.value
                                                            })
                                                        ]
                                                    }),
                                                    selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "jsx-cf56417ef7cbaa5a" + " " + (classnames_default()("absolute inset-y-0 right-1 flex items-center pl-3", active ? "text-amber-600" : "text-amber-600") || ""),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                                                            className: "w-5 h-5",
                                                            "aria-hidden": "true"
                                                        })
                                                    }) : null
                                                ]
                                            });
                                        }
                                    }, opt.value);
                                }),
                                endButton
                            ]
                        })
                    })
                ]
            })
        })
    });
});
Select.SelectButton = SelectButton;
function SelectButton(_param) {
    var className = _param.className, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    var hoverClasses = "hover:bg-gray-100 hover:dark:bg-gray-600 rounded mx-2";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()("flex space-x-2 py-[5px] pl-2 text-left items-center font-medium text-sm", hoverClasses, className)
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon/* default */.Z, {
                className: "w-4 h-4 mx-px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            })
        ]
    }));
}





(0,colord/* extend */.l7)([
    mix/* default */.Z,
    harmonies/* default */.Z
]);
var colorHash = new (color_hash_default())({
    lightness: 0.6
});
function GradientIcon(param) {
    var name = param.name;
    var width = 18;
    var background = function() {
        if (!name) {
            return "#aaa";
        }
        var color = colorHash.hex(name);
        var ref = (0,_sliced_to_array/* default */.Z)((0,colord/* colord */.Vi)(color).harmonies("analogous"), 2), first = ref[0], second = ref[1];
        return "linear-gradient(to right, ".concat(first.toHex(), ", ").concat(second.desaturate(0.3).toHex(), ")");
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            background: background,
            width: width,
            height: width
        },
        className: "rounded-md shrink-0 "
    });
}

// EXTERNAL MODULE: ./src/pages/api/functions.ts
var functions = __webpack_require__(92407);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-hot-toast@2.2.0_biqbaboplfbrettd7655fr4n2y/node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(72986);
;// CONCATENATED MODULE: ./src/components/SelectOrg.tsx












var swrKey = "SelectOrg";
function SelectOrg(param) {
    var _doNotRedirect = param.doNotRedirect, doNotRedirect = _doNotRedirect === void 0 ? false : _doNotRedirect, _className = param.className, className = _className === void 0 ? "" : _className;
    // i need to mutate the orgs key every time the orgs list changes
    var ref = (0,dist/* default */.ZP)(swrKey, functions/* getUserOrgs */.nS), data = ref.data, error = ref.error, mutate = ref.mutate;
    // console.log({ data })
    var orgs = (data === null || data === void 0 ? void 0 : data.orgs) || [];
    (0,react.useEffect)(function() {
        if (error) {
            react_hot_toast_esm/* toast.error */.Am.error(error.message);
        }
    }, [
        error
    ]);
    var router = (0,next_router.useRouter)();
    var orgId = router.query.orgId || "";
    (0,react.useEffect)(function() {
        if (data && !doNotRedirect && orgs.length && !orgId) {
            var id = orgs[0].id;
            console.log("redirecting to org ".concat(id));
            router.push("/board/org/".concat(id));
        }
    }, [
        orgs,
        orgId
    ]);
    var ref1 = (0,utils/* useThrowingFn */.Sl)({
        fn: function() {
            var _onChange = (0,_async_to_generator/* default */.Z)(function(value) {
                var org, newPath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            org = orgs === null || orgs === void 0 ? void 0 : orgs.find(function(org) {
                                return String(org.id) === value;
                            });
                            if (!org) {
                                console.warn("no org found", value);
                                return [
                                    2
                                ];
                            }
                            newPath = "/board/org/".concat(org.id);
                            return [
                                4,
                                router.replace(newPath)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            function onChange(value) {
                return _onChange.apply(this, arguments);
            }
            return onChange;
        }()
    }), onChange = ref1.fn, isOrgLoading = ref1.isLoading;
    var ref2 = (0,utils/* useThrowingFn */.Sl)({
        fn: function() {
            var _onSubmit = (0,_async_to_generator/* default */.Z)(function(_$param) {
                var _$param;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _$param = _$param !== null ? _$param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
                            return [
                                4,
                                router.push("/new")
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            function onSubmit(_) {
                return _onSubmit.apply(this, arguments);
            }
            return onSubmit;
        }(),
        successMessage: "",
        errorMessage: ""
    }), newOrg = ref2.fn, isLoadingNewOrg = ref2.isLoading;
    var current = orgs.find(function(org) {
        return String(org.id) === orgId;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
            useAutoGradientIcons: true,
            isLoading: isLoadingNewOrg || !current,
            value: orgId,
            onChange: onChange,
            className: classnames_default()("min-w-[16ch] !border-0", className),
            endButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.SelectButton, {
                children: "New Org",
                onClick: newOrg
            }),
            options: orgs.map(function(o) {
                return {
                    value: String(o.id),
                    name: o.name
                };
            })
        })
    });
}
SelectOrg.swrKey = swrKey;


/***/ }),

/***/ 44329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tO": function() { return /* binding */ MyFaq; },
  "iX": function() { return /* binding */ MyFooter; },
  "fC": function() { return /* binding */ MyHeader; },
  "RR": function() { return /* binding */ MyNavbar; },
  "KD": function() { return /* binding */ MyPricing; }
});

// UNUSED EXPORTS: LoginLink, Logo

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(61706);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(29859);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(89874);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(96424);
// EXTERNAL MODULE: ../node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(98725);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/styled-jsx@5.0.7_react@18.2.0/node_modules/styled-jsx/style.js
var style = __webpack_require__(65184);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.2_biqbaboplfbrettd7655fr4n2y/node_modules/next/link.js
var next_link = __webpack_require__(23185);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(42928);
// EXTERNAL MODULE: ../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(19841);
// EXTERNAL MODULE: ../node_modules/.pnpm/next-auth@4.12.2_nitggutgekmxcbakccyp3sboiq/node_modules/next-auth/react/index.js
var react = __webpack_require__(68278);
// EXTERNAL MODULE: ../node_modules/.pnpm/color-hash@2.0.1/node_modules/color-hash/dist/color-hash.js
var color_hash = __webpack_require__(79758);
var color_hash_default = /*#__PURE__*/__webpack_require__.n(color_hash);
// EXTERNAL MODULE: ../node_modules/.pnpm/colord@2.9.2/node_modules/colord/index.mjs
var colord = __webpack_require__(85799);
// EXTERNAL MODULE: ../node_modules/.pnpm/colord@2.9.2/node_modules/colord/plugins/harmonies.mjs
var harmonies = __webpack_require__(1323);
// EXTERNAL MODULE: ../node_modules/.pnpm/colord@2.9.2/node_modules/colord/plugins/mix.mjs
var mix = __webpack_require__(96562);
;// CONCATENATED MODULE: ../beskar/src/Header.tsx








function DashboardHeader(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, logo = _param.logo, _links = _param.links, links = _links === void 0 ? [] : _links, menu = _param.menu, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "logo",
        "links",
        "menu"
    ]);
    var ref = (0,react.useSession)(), session = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)("z-10 relative w-full py-4 flex mx-auto space-x-4",  true ? "items-end" : 0, className)
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center gap-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col justify-center space-y-4",
                    children: logo
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-auto"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center md:space-x-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden space-x-8 items-center md:flex",
                            children: Array.isArray(links) ? links.map(function(x, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: x
                                }, i);
                            }) : links
                        }),
                        menu
                    ]
                })
            })
        ]
    }));
}




(0,colord/* extend */.l7)([
    mix/* default */.Z,
    harmonies/* default */.Z
]);
var colorHash = new (color_hash_default())({
    lightness: 0.6
});
function AvatarButton(param) {
    var className = param.className, tmp = param.as, As = tmp === void 0 ? "button" : tmp, name = param.name;
    var background = function() {
        if (!name) {
            return "#aaa";
        }
        var color = colorHash.hex(name);
        var ref = (0,_sliced_to_array/* default */.Z)((0,colord/* colord */.Vi)(color).harmonies("analogous"), 2), first = ref[0], second = ref[1];
        return "linear-gradient(to right, ".concat(first.desaturate(0.2).toHex(), ", ").concat(second.desaturate(0.4).toHex(), ")");
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(As, {
        role: "button",
        "aria-label": "avatar button",
        style: {
            background: background
        },
        className: "rounded-full w-12 h-12 active:opacity-40" + className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSvg, {
            className: "opacity-80"
        })
    });
}
function ProfileSvg(_param) {
    var rest = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 128 128",
        className: "",
        role: "img",
        "aria-label": " avatar"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
            })
        ]
    }));
}

// EXTERNAL MODULE: ../beskar/landing.ts
var landing = __webpack_require__(84045);
// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/outline/esm/MoonIcon.js
var MoonIcon = __webpack_require__(47859);
// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/outline/esm/SunIcon.js
var SunIcon = __webpack_require__(49661);
// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/outline/esm/CogIcon.js
var CogIcon = __webpack_require__(2773);
// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/outline/esm/LogoutIcon.js
var LogoutIcon = __webpack_require__(41388);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.2_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(77577);
// EXTERNAL MODULE: ../beskar/src/landing/Spinner.tsx
var Spinner = __webpack_require__(33550);
// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/solid/esm/CheckCircleIcon.js
var CheckCircleIcon = __webpack_require__(66182);
// EXTERNAL MODULE: ../node_modules/.pnpm/baby-i-am-faded@4.0.14_react@18.2.0/node_modules/baby-i-am-faded/esm/index.js + 1 modules
var esm = __webpack_require__(37833);
// EXTERNAL MODULE: ../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(65443);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var node_modules_react = __webpack_require__(70079);
// EXTERNAL MODULE: ../beskar/src/landing/Link.tsx
var Link = __webpack_require__(86650);
// EXTERNAL MODULE: ../beskar/src/utils.ts
var utils = __webpack_require__(2177);
// EXTERNAL MODULE: ../beskar/src/landing/PageContainer.tsx
var PageContainer = __webpack_require__(12028);
// EXTERNAL MODULE: ../beskar/src/landing/Button.tsx
var Button = __webpack_require__(42200);
// EXTERNAL MODULE: ../node_modules/.pnpm/@formatjs+intl-numberformat@8.0.4/node_modules/@formatjs/intl-numberformat/polyfill.js
var polyfill = __webpack_require__(63446);
// EXTERNAL MODULE: ../node_modules/.pnpm/@formatjs+intl-numberformat@8.0.4/node_modules/@formatjs/intl-numberformat/locale-data/en.js
var en = __webpack_require__(69123);
;// CONCATENATED MODULE: ../beskar/src/landing/PricingSlider.tsx


















// const getSubscriptionMemoized = memoize(getSubscription, { isPromise: true })
function PricingSlider(_param) {
    var refetchSubscription = function refetchSubscription() {
        setSubscription(undefined);
        getSubscription().then(function(subscription) {
            if (subscription) {
                setSubscription(subscription);
            }
        });
    };
    var _products = _param.products, products = _products === void 0 ? [] : _products, _animate = _param.animate, animate = _animate === void 0 ? false : _animate, _className = _param.className, className = _className === void 0 ? "" : _className, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, onCheckout = _param.onCheckout, trialDays = _param.trialDays, _promptLogin = _param.promptLogin, promptLogin = _promptLogin === void 0 ? function promptLogin() {
        (0,react.signIn)();
    } : _promptLogin, updatePlan = _param.updatePlan, _hideUpgradeButton = _param.hideUpgradeButton, hideUpgradeButton = _hideUpgradeButton === void 0 ? false : _hideUpgradeButton, getSubscription = _param.getSubscription, features = _param.features, manageSubscriptionHandler = _param.manageSubscriptionHandler, _pricesCurrency = _param.pricesCurrency, pricesCurrency = _pricesCurrency === void 0 ? "usd" : _pricesCurrency, _allowYearlyBilling = _param.allowYearlyBilling, allowYearlyBilling = _allowYearlyBilling === void 0 ? true : _allowYearlyBilling, needMoreEmail = _param.needMoreEmail, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "products",
        "animate",
        "className",
        "isLoading",
        "onCheckout",
        "trialDays",
        "promptLogin",
        "updatePlan",
        "hideUpgradeButton",
        "getSubscription",
        "features",
        "manageSubscriptionHandler",
        "pricesCurrency",
        "allowYearlyBilling",
        "needMoreEmail"
    ]);
    var ref = (0,node_modules_react.useState)(), subscription = ref[0], setSubscription = ref[1];
    var ref1 = (0,react.useSession)(), status = ref1.status, session = ref1.data;
    var ref2 = (0,node_modules_react.useState)("month"), billingInterval = ref2[0], setBillingInterval = ref2[1];
    (0,node_modules_react.useEffect)(function() {
        void (0,_async_to_generator/* default */.Z)(function() {
            var subscription;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (status !== "authenticated") {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            getSubscription()
                        ];
                    case 1:
                        subscription = _state.sent();
                        if (subscription) {
                            setSubscription(subscription);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        status
    ]);
    var FadedComponent = animate ? esm/* Faded */.A : "div";
    var ranges = products.sort(function(a, b) {
        var ref, ref1, ref2, ref3;
        return ((ref1 = a === null || a === void 0 ? void 0 : (ref = a.prices) === null || ref === void 0 ? void 0 : ref.find(function(one) {
            return one.currency === pricesCurrency;
        })) === null || ref1 === void 0 ? void 0 : ref1.unitAmount) - ((ref3 = b === null || b === void 0 ? void 0 : (ref2 = b.prices) === null || ref2 === void 0 ? void 0 : ref2.find(function(one) {
            return one.currency === pricesCurrency;
        })) === null || ref3 === void 0 ? void 0 : ref3.unitAmount);
    }).filter(function(x) {
        if (status === "authenticated") {
            return x.prices.every(function(p) {
                return p.unitAmount > 0;
            });
        }
        return true;
    }).map(function(product) {
        var ref;
        var price = product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.find(function(one) {
            return one.currency === pricesCurrency;
        });
        if (!price) {
            return null;
        }
        if (product.billing_type !== billingInterval) {
            return null;
        }
        return {
            price: price.unitAmount,
            limits: product.limits,
            productId: product.productId
        };
    }).filter(Boolean);
    var ref3 = (0,node_modules_react.useState)(-1), currentProductIndex = ref3[0], setCurrentProductIndex = ref3[1];
    (0,node_modules_react.useEffect)(function() {
        if (!(ranges === null || ranges === void 0 ? void 0 : ranges.length)) {
            return setCurrentProductIndex(-1);
        }
        setCurrentProductIndex(0);
    }, [
        ranges.length,
        billingInterval
    ]);
    var currentRange = ranges[currentProductIndex] || null;
    var price = function() {
        if (!currentRange) {
            return null;
        }
        var p = (currentRange === null || currentRange === void 0 ? void 0 : currentRange.price) / 100;
        return p;
    }();
    var ref4 = (0,utils/* useThrowingFn */.Sl)({
        fn: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, productId, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        productId = currentRange === null || currentRange === void 0 ? void 0 : currentRange.productId;
                        if (!productId) {
                            return [
                                2
                            ];
                        }
                        if (status !== "authenticated" && promptLogin) {
                            return [
                                2,
                                promptLogin()
                            ];
                        }
                        if (!(session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.id)) {
                            throw new Error("User ID is missing");
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            6,
                            9
                        ]);
                        if (!subscription) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            updatePlan({
                                subscriptionId: subscription.id,
                                planId: productId
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 100);
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            refetchSubscription()
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        return [
                            2,
                            {
                                skipToast: true
                            }
                        ];
                    case 6:
                        if (!onCheckout) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            onCheckout({
                                productId: productId,
                                isChangePlan: Boolean(subscription),
                                email: (session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.email) || "",
                                userId: session === null || session === void 0 ? void 0 : (ref2 = session.user) === null || ref2 === void 0 ? void 0 : ref2.id
                            })
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        })
    }), handlePricingClick = ref4.fn, clickIsLoading = ref4.isLoading;
    var buttonText = function() {
        if ((subscription === null || subscription === void 0 ? void 0 : subscription.productId) === (currentRange === null || currentRange === void 0 ? void 0 : currentRange.productId)) {
            return "Current plan";
        }
        if (subscription) {
            return "Change plan";
        }
        if (!session) {
            return "Start free trial";
        }
        return "Upgrade";
    }();
    var disabled = (subscription === null || subscription === void 0 ? void 0 : subscription.productId) === (currentRange === null || currentRange === void 0 ? void 0 : currentRange.productId) || isLoading;
    // console.log({ currentRange })
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContainer/* PageContainer */._, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: "pricing"
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FadedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animate && {
            cascade: true,
            whenInView: true,
            triggerOnce: true
        }), {
            className: classnames_default()("w-full max-w-[900px] shadow-xl self-center rounded relative", "px-12 p-8 mx-auto gap-6 flex-col flex bg-white", "dark:bg-gray-800", className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap gap-4 font-medium",
                    children: [
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-start gap-8",
                            children: Object.keys((currentRange === null || currentRange === void 0 ? void 0 : currentRange.limits) || {}).map(function(k, i) {
                                var limit = currentRange === null || currentRange === void 0 ? void 0 : currentRange.limits[k];
                                if (typeof limit === "number") {
                                    limit = formatBigNumber(limit);
                                }
                                if (limit === false) {
                                    return null;
                                }
                                if (limit === true) {
                                    limit = "";
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "opacity-80 truncate uppercase",
                                            children: k
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-semibold text-3xl",
                                            children: limit
                                        })
                                    ]
                                }, k + i);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "opacity-80 text-right",
                                    children: "PRICE"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "font-semibold text-3xl truncate",
                                    children: [
                                        "$",
                                        price,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "opacity-70 font-medium",
                                            children: " / mo"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSlider, {
                    value: currentProductIndex,
                    onChange: function onChange(e) {
                        var ref;
                        var v = (ref = Number(e.target.value)) !== null && ref !== void 0 ? ref : -1;
                        // console.log({ v })
                        setCurrentProductIndex(v);
                    },
                    min: 0,
                    max: (ranges === null || ranges === void 0 ? void 0 : ranges.length) - 1,
                    step: 1
                }),
                allowYearlyBilling && /*#__PURE__*/ (0,jsx_runtime.jsx)(BillingIntervalSelect, {
                    billingInterval: billingInterval,
                    setBillingInterval: setBillingInterval
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "uppercase font-semibold text-sm opacity-80",
                            children: "what's included"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grow border-t-2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-3 gap-y-8 gap-x-8",
                    children: features.map(function(feature, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-2 justify-center items-center",
                            children: [
                                i % 3 === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grow"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleIcon/* default */.Z, {
                                    className: "h-5 dark:fill-green-300 fill-green-500"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: feature
                                }),
                                i % 3 === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grow"
                                })
                            ]
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex mt-4 justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            !hideUpgradeButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                "aria-label": "buy",
                                onClick: handlePricingClick,
                                disabled: disabled,
                                // bg='blue.500'
                                // bgDark='blue.200'
                                isLoading: clickIsLoading,
                                biggerOnHover: true,
                                className: "font-bold !px-6",
                                children: buttonText
                            }),
                            Boolean(trialDays) && !subscription && !session && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "opacity-70 text-center font-medium text-xs",
                                children: [
                                    trialDays,
                                    " days free trial"
                                ]
                            })
                        ]
                    })
                }),
                subscription && manageSubscriptionHandler ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    className: "mx-auto !mb-0",
                    onClick: function onClick(e) {
                        e.preventDefault();
                        manageSubscriptionHandler();
                    },
                    href: "",
                    children: "Manage subscription"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FadedComponent, {
                    className: "text-center mx-auto !mb-0 opacity-80 text-sm",
                    children: [
                        "Need more?",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "mailto:".concat(needMoreEmail, "?subject=").concat(encodeURIComponent("Need a custom plan")),
                            children: "Contact me"
                        })
                    ]
                })
            ]
        }))
    }));
}
function BillingIntervalSelect(param) {
    var billingInterval = param.billingInterval, setBillingInterval = param.setBillingInterval;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("relative self-center bg-gray-200 rounded-lg", "p-0.5 flex"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function onClick() {
                    return setBillingInterval("month");
                },
                type: "button",
                className: classnames_default()("whitespace-nowrap w-1/2 text-sm text-gray-700", "rounded-lg relative py-2 font-medium sm:w-auto", "sm:px-8 focus:z-10 focus:ring-2 focus:outline-none", {
                    "bg-white border-gray-200 shadow-sm rounded-md text-gray-900": billingInterval === "month",
                    "bg-transparent": billingInterval !== "month"
                }),
                children: "Monthly billing"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function onClick() {
                    return setBillingInterval("year");
                },
                type: "button",
                className: classnames_default()("whitespace-nowrap w-1/2 text-sm text-gray-700", "rounded-lg relative py-2 font-medium bg-white", "sm:w-auto sm:px-8 focus:z-10 focus:ring-2 focus:outline-none", {
                    "bg-white border-gray-200 shadow-sm rounded-md text-gray-900": billingInterval === "year",
                    "bg-transparent": billingInterval !== "year"
                }),
                children: "Yearly billing"
            })
        ]
    });
}
function RangeSlider(_param) {
    var min = _param.min, max = _param.max, _bg = _param.bg, bg = _bg === void 0 ? "#388bd2" : _bg, step = _param.step, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "min",
        "max",
        "bg",
        "step"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: style_default().dynamic([
            [
                "21825d0e90ea0342",
                [
                    bg,
                    bg,
                    bg
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "range",
                min: min,
                max: max,
                step: step
            }, rest), {
                className: style_default().dynamic([
                    [
                        "21825d0e90ea0342",
                        [
                            bg,
                            bg,
                            bg
                        ]
                    ]
                ]) + " " + (rest && rest.className != null && rest.className || "range px-3")
            })),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "21825d0e90ea0342",
                dynamic: [
                    bg,
                    bg,
                    bg
                ],
                children: 'input[type="range"].__jsx-style-dynamic-selector{-moz-appearance:none;-webkit-appearance:none;background:rgba(0,0,0,.1);-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;height:6px;width:100%;margin-top:15px;margin-bottom:15px;outline:0}.dark input[type="range"].__jsx-style-dynamic-selector{background:rgba(255,255,255,.1)}input[type="range"].__jsx-style-dynamic-selector::-webkit-slider-thumb{-moz-appearance:none;-ms-appearance:none;appearance:none;-webkit-box-shadow:0 0 40px rgba(0,0,0,.2);-moz-box-shadow:0 0 40px rgba(0,0,0,.2);box-shadow:0 0 40px rgba(0,0,0,.2);-webkit-appearance:none;background-color:'.concat(bg, ';background-image:url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2212%22%20height%3D%228%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8%20.5v7L12%204zM0%204l4%203.5v-7z%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E");background-position:center;background-repeat:no-repeat;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;cursor:pointer;height:36px;width:36px}input[type="range"].__jsx-style-dynamic-selector::-moz-range-thumb{background-color:').concat(bg, ';background-image:url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2212%22%20height%3D%228%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8%20.5v7L12%204zM0%204l4%203.5v-7z%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E");background-position:center;background-repeat:no-repeat;border:0;border:0;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;cursor:pointer;height:36px;width:36px}input[type="range"].__jsx-style-dynamic-selector::-ms-thumb{background-color:').concat(bg, ';background-image:url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2212%22%20height%3D%228%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8%20.5v7L12%204zM0%204l4%203.5v-7z%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E");background-position:center;background-repeat:no-repeat;border:0;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;cursor:pointer;height:36px;width:36px}input[type="range"].__jsx-style-dynamic-selector::-moz-focus-outer{border:0}')
            })
        ]
    });
}


function formatBigNumber(n) {
    var formatter = new Intl.NumberFormat("en-US", {
        compactDisplay: "short",
        notation: "compact"
    });
    return formatter.format(n);
}

// EXTERNAL MODULE: ../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/menu/menu.js + 2 modules
var menu = __webpack_require__(93336);
// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(40914);
;// CONCATENATED MODULE: ../beskar/src/DropDown.tsx









function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function DropDownMenu(props) {
    var children = props.children, button = props.button;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu */.v, {
        as: "div",
        className: classNames("relative inline-block text-left", props.className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Button */.v.Button, {
                as: "div",
                children: button
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "7d14bef2eb999215",
                children: "@-webkit-keyframes menuAppear{from{opacity:0;-webkit-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@-moz-keyframes menuAppear{from{opacity:0;-moz-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@-o-keyframes menuAppear{from{opacity:0;transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@keyframes menuAppear{from{opacity:0;-webkit-transform:translate3d(0px,-2em,0px)scale(0);-moz-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Faded */.A, {
                animationName: "menuAppear",
                duration: 120,
                cascade: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Items */.v.Items, {
                    className: "absolute border py-1 right-0 w-56 mt-2 origin-top-right bg-white rounded-md shadow-lg dark:bg-gray-800 ring-1 ring-black ring-opacity-5 focus:outline-none",
                    children: children
                })
            })
        ]
    });
}
DropDownMenu.Button = DropDown_Button;
function DropDown_Button(_param) {
    var className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: classNames("inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 dark:hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500", "cursor-pointer", className),
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                className: "w-5 h-5 ml-2 -mr-1",
                "aria-hidden": "true"
            })
        ]
    });
}
var Item = /*#__PURE__*/ (0,node_modules_react.forwardRef)(function Item(_param, ref) {
    var _icon = _param.icon, icon = _icon === void 0 ? null : _icon, children = _param.children, _className = _param.className, className = _className === void 0 ? "" : _className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
        children: function children1(param) {
            var active = param.active;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classNames(active ? "bg-gray-100 text-gray-900" : "", "flex space-x-3 px-4 py-2 text-sm rounded-md m-1", "cursor-pointer", className),
                ref: ref
            }, rest), {
                children: [
                    icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: children
                    })
                ]
            }));
        }
    });
});
DropDownMenu.Item = Item;

// EXTERNAL MODULE: ./src/components/SelectOrg.tsx + 1 modules
var SelectOrg = __webpack_require__(18717);
// EXTERNAL MODULE: ./src/pages/api/functions.ts
var functions = __webpack_require__(92407);
// EXTERNAL MODULE: ./src/utils/index.ts + 1 modules
var src_utils = __webpack_require__(88286);
// EXTERNAL MODULE: ../node_modules/.pnpm/swr@1.3.0_react@18.2.0/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(12976);
// EXTERNAL MODULE: ../node_modules/.pnpm/jotai@1.7.6_react@18.2.0/node_modules/jotai/esm/index.js
var jotai_esm = __webpack_require__(42385);
// EXTERNAL MODULE: ./src/utils/atoms.ts
var atoms = __webpack_require__(26081);
// EXTERNAL MODULE: ./src/pages/api/stripe.ts
var api_stripe = __webpack_require__(70853);
// EXTERNAL MODULE: ../db/data.tsx
var data = __webpack_require__(16179);
// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/solid/esm/ChevronLeftIcon.js
var ChevronLeftIcon = __webpack_require__(93761);
;// CONCATENATED MODULE: ./src/components/specific.tsx





























function MyHeader(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var router = (0,next_router.useRouter)();
    var showBackButton = !!router.query.campId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardHeader, {
        logo: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-3 ",
            children: [
                showBackButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToOrg, {
                    name: ""
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                    className: "!text-3xl "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-3 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOrg/* SelectOrg */.m, {
                            // there is no site in user settings, just keep loading state
                            doNotRedirect: router.asPath === "/board/settings" || router.asPath === "/new" || router.asPath.startsWith("/upgrade")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeTrialRemaining, {
                            className: "hidden md:block"
                        })
                    ]
                })
            ]
        }),
        links: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
                    href: "/blog",
                    children: "Blog"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
                    href: "/home",
                    children: "Home"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* FeedbackWithCrisp */.gn, {
                    useDefaultComponent: true
                })
            ]
        }),
        menu: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarMenu, {})
    });
}
function BackToOrg(param) {
    var _name = param.name, name = _name === void 0 ? "" : _name;
    var router = (0,next_router.useRouter)();
    var orgId = router.query.orgId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center gap-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Button */.zx, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeftIcon/* default */.Z, {
                    className: "h-5"
                }),
                bg: "gray.100",
                bgDark: "gray.800",
                className: "opacity-70 font-medium text-sm",
                href: "/board/org/".concat(orgId),
                children: "Other campaigns"
            }),
            name && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-xl opacity-70",
                children: name
            })
        ]
    });
}
function FreeTrialRemaining(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    var router = (0,next_router.useRouter)();
    var orgId = router.query.orgId;
    var ref = (0,dist/* default */.ZP)([
        "getSub",
        orgId
    ], function(_, orgId) {
        return (0,functions/* getSubscription */.pI)({
            orgId: orgId
        });
    }), data = ref.data, error = ref.error, isValidating = ref.isValidating;
    var updateUpgradeModal = (0,jotai_esm/* useSetAtom */.b9)(atoms/* atomUpgradeModal */.Q7);
    if (!orgId) {
        return null;
    }
    if (!data) {
        return null;
    }
    // show 0 trial days even if user unsubscribed or trial ended
    if (!data.subscription) {
        var days = data.trialDaysRemaining;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Faded */.A, {
            animationName: "simpleFadeIn",
            children: [
                (0,jsx_runtime.jsx)((style_default()), {
                    id: "90a409d633f15c86",
                    children: "@-webkit-keyframes simpleFadeIn{from{opacity:0}to{opacity:1}}@-moz-keyframes simpleFadeIn{from{opacity:0}to{opacity:1}}@-o-keyframes simpleFadeIn{from{opacity:0}to{opacity:1}}@keyframes simpleFadeIn{from{opacity:0}to{opacity:1}}"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(landing/* Button */.zx, {
                    onClick: function() {
                        updateUpgradeModal({
                            isOpen: true,
                            reason: "Upgrade"
                        });
                    },
                    ghost: true,
                    className: classnames_default()("text-sm truncate capitalize opacity-70 font-medium", className),
                    children: [
                        days,
                        " trial days left"
                    ]
                })
            ]
        });
    }
}
function MyNavbar(param) {
    var _canLogout = param.canLogout, canLogout = _canLogout === void 0 ? false : _canLogout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* NavBar */.l2, {
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {}),
        navs: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
                    href: "/blog",
                    children: "Blog"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
                    href: "https://changelog.salespack.io",
                    target: "_blank",
                    children: "Changelog"
                }),
                canLogout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
                    href: "",
                    onClick: function(e) {
                        e.preventDefault();
                        (0,react.signOut)();
                    },
                    children: "Sign Out"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginLink, {})
            ]
        })
    });
}
function MyFooter(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Footer */.$_, {
        // justifyAround
        columns: {
            Company: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
                    href: "/blog",
                    children: "Blog"
                })
            }),
            "Who made this?": /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
                        href: "https://twitter.com/__morse",
                        children: "My Twitter"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
                        href: "mailto:tommy@salespack.io",
                        children: "Contact me"
                    })
                ]
            })
        }
    });
}
function AvatarMenu(param) {
    var _imgSrc = param.imgSrc, imgSrc = _imgSrc === void 0 ? "" : _imgSrc;
    var ref;
    var ref1 = (0,landing/* useColorMode */.If)(), toggleColorMode = ref1.toggleColorMode, isDark = ref1.isDark;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useSession)(), session = ref2.data;
    var avatar = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarButton, {
            // squared
            // textColor={'white'}
            // color='gradient'
            className: "border",
            name: session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.name
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownMenu, {
        button: avatar,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownMenu.Item, {
                onClick: toggleColorMode,
                icon: (0,landing/* useColorModeValue */.ff)(/*#__PURE__*/ (0,jsx_runtime.jsx)(MoonIcon/* default */.Z, {
                    className: "w-5 h-5 opacity-60"
                }), /*#__PURE__*/ (0,jsx_runtime.jsx)(SunIcon/* default */.Z, {
                    className: "w-5 h-5 opacity-60"
                })),
                children: !isDark ? "Dark mode" : "Light Mode"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "/board/settings",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownMenu.Item, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CogIcon/* default */.Z, {
                        className: "w-5 h-5 opacity-60"
                    }),
                    children: "Settings"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownMenu.Item, {
                onClick: function() {
                    return (0,react.signOut)({
                        callbackUrl: "/"
                    });
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutIcon/* default */.Z, {
                    className: "w-5 h-5 opacity-60"
                }),
                children: "Sign out"
            })
        ]
    });
}
function Logo(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    // const { status } = useSession()
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        legacyBehavior: true,
        href: "/",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: classnames_default()("text-4xl space-x-3 items-center font-medium", "flex", className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoIcon, {
                    className: "h-[24px]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: "Salespack"
                })
            ]
        })
    });
}
function LogoIcon(_param) {
    var rest = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 32,
        viewBox: "0 0 30 32"
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M9.9,29.7840402 L0.93,13.9973735 C0.345,13.0221354 0,11.9402307 0,10.7364211 C0.00276767676,7.67006673 2.24801082,5.08341757 5.24237876,4.69689945 C8.2367467,4.31038133 11.0474327,6.24440255 11.805,9.21261161 L18,9.21261161 L18,5.4030878 C18,3.72689732 19.35,2.35546875 21,2.35546875 L21,6.30213542 L23.385,3.87927827 L30,3.87927827 L30,6.92689732 L24.615,6.92689732 L21,10.5992783 L21,10.873564 L24.615,14.5459449 L30,14.5459449 L30,17.593564 L23.385,17.593564 L21,15.1707068 L21,19.1173735 C19.3431458,19.1173735 18,17.752908 18,16.0697545 L18,12.2602307 L11.805,12.2602307 C11.655,12.8545164 11.415,13.4183259 11.115,13.9364211 L20.115,29.7840402 L27,29.7840402 C28.6568542,29.7840402 30,31.1485057 30,32.8316592 L30,34.3554688 L0,34.3554688 L0,32.8316592 C0,31.1554687 1.35,29.7840402 3,29.7840402 L9.9,29.7840402 Z M8.865,16.0697545 C8.025,16.5573735 7.05,16.8316592 6,16.8316592 L13.365,29.7840402 L16.65,29.7840402 L8.865,16.0697545 M6,7.68880208 C4.34314575,7.68880208 3,9.05326761 3,10.7364211 C3,12.4278497 4.335,13.7840402 6,13.7840402 C7.665,13.7840402 9,12.4278497 9,10.7364211 C9,9.05326761 7.65685425,7.68880208 6,7.68880208 Z",
            transform: "translate(0 -2.355)"
        })
    }));
}
function LoginLink(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var status = (0,react.useSession)().status;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-[14ch] text-left md:text-center",
        children: status === "authenticated" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
            onClick: function() {
                return router.push("/board");
            },
            children: "Go to Dashboard"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
            "data-name": "login",
            onClick: function() {
                return (0,react.signIn)(undefined, {
                    callbackUrl: "/board",
                    redirect: true
                }, {
                    prompt: "select_account"
                });
            },
            children: "Login or Sign Up"
        })
    }, status);
}
var CONTACT_US_LINK = "mailto:tommy@salespack.io";
var lifetimeProductIds = data/* subscriptionPlansConfig.filter */.nI.filter(function(x) {
    return x.isLifetime;
}).map(function(x) {
    return x.productId;
});
function MyPricing(_param) {
    var onCheckout = _param.onCheckout, orgId = _param.orgId, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "onCheckout",
        "orgId"
    ]);
    var ref = (0,landing/* useThrowingFn */.Sl)({
        fn: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var url;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!orgId) {
                            window.location.href = "/board";
                            return [
                                2,
                                {
                                    skipToast: true
                                }
                            ];
                        }
                        return [
                            4,
                            (0,api_stripe/* createStripePortal */.p)({
                                orgId: orgId
                            })
                        ];
                    case 1:
                        url = _state.sent().url;
                        window.location.href = url;
                        return [
                            2,
                            {
                                skipToast: true
                            }
                        ];
                }
            });
        })
    }), createPortalClient = ref.fn, isLoadingPortal = ref.isLoading;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingSlider, (0,_object_spread/* default */.Z)({
        products: [],
        allowYearlyBilling: false,
        features: [
            "Unlimited email accounts",
            "Priority Support",
            "Email warmup", 
        ],
        needMoreEmail: "tommy@salespack.io",
        trialDays: 7,
        getSubscription: function getSubscription1() {
            return (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, d, sub;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,functions/* getSubscription */.pI)({
                                    orgId: orgId
                                })
                            ];
                        case 1:
                            d = _state.sent();
                            if ((d === null || d === void 0 ? void 0 : (ref = d.subscription) === null || ref === void 0 ? void 0 : ref.productId) && lifetimeProductIds.includes(d === null || d === void 0 ? void 0 : (ref1 = d.subscription) === null || ref1 === void 0 ? void 0 : ref1.productId)) {
                                // lifetime deals cannot be upgraded
                                return [
                                    2,
                                    null
                                ];
                            }
                            sub = d === null || d === void 0 ? void 0 : d.subscription;
                            if (!sub) {
                                return [
                                    2,
                                    null
                                ];
                            }
                            return [
                                2,
                                {
                                    id: sub === null || sub === void 0 ? void 0 : sub.id,
                                    productId: sub === null || sub === void 0 ? void 0 : sub.priceId,
                                    unit_price: sub === null || sub === void 0 ? void 0 : sub.unit_amount
                                }
                            ];
                    }
                });
            })();
        },
        updatePlan: function updatePlan(param) {
            var planId = param.planId, subscriptionId = param.subscriptionId;
            return (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                createPortalClient()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        manageSubscriptionHandler: createPortalClient,
        onCheckout: function onCheckout(arg) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var sessionId, stripe;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,api_stripe/* createStripeCheckoutSession */.R)({
                                    orgId: orgId,
                                    priceId: arg.productId
                                })
                            ];
                        case 1:
                            sessionId = _state.sent().sessionId;
                            return [
                                4,
                                (0,src_utils/* getStripe */.d2)()
                            ];
                        case 2:
                            stripe = _state.sent();
                            return [
                                4,
                                stripe === null || stripe === void 0 ? void 0 : stripe.redirectToCheckout({
                                    sessionId: sessionId
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            // onCheckout && onCheckout(arg)
            })();
        }
    }, rest));
}
function MyFaq(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(landing/* PageContainer */._z, {
        className: classnames_default()("max-w-5xl px-4 w-full", "lg:px-0", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-3xl font-semibold text-center",
                children: "Frequently asked questions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Faq */.By, {
                className: "min-w-full text-gray-800",
                items: [
                    {
                        heading: "Can i use Salespack for my agency?",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                "Yes! We have a members system that lets you invite members to your org and let them monitor the campaigns analytics and stats.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Usually we recommend that you create a separate org for each client."
                            ]
                        })
                    },
                    {
                        heading: "Do you have a free trial?",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Yes! All plans have a 7 days free trial."
                        })
                    },
                    {
                        heading: "What email accounts can i use?",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                "You can use any email accounts supporting SMTP and IMAP (basically all providers, Google requires some additional steps to enabled SMTP)",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "If you are searching for an email provider, we recommend using Zoho.us, it lets you connect up to 30 domains on a single plan (notice the .us domain, the .eu service is much worse)"
                            ]
                        })
                    },
                    {
                        heading: "What is email warmup?",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                "If you enable warmup for your email accounts we will send emails from your account to other Salespack users.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "This lets you monitor if your emails end up in spam and makes ISPs increase the trust scores of your email accounts.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "We will also move emails that end up in spam to the main inbox.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "All warmup emails you receive will be moved to a separate folder to not clutter your inbox."
                            ]
                        })
                    },
                    {
                        heading: "How are page emails counted?",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                "Every email you send in a campaign (counting follow ups) increments your org count.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Warmup emails are not counted."
                            ]
                        })
                    },
                    {
                        heading: "Who is behind Salespack?",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "",
                            children: [
                                "I am Tommy, a software engineer living in Italy. you can chat with me on",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* Link */.rU, {
                                    underline: true,
                                    href: "https://twitter.com/__morse",
                                    children: "Twitter"
                                }),
                                " ",
                                ":)."
                            ]
                        })
                    }, 
                ]
            })
        ]
    });
}


/***/ })

}]);